(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["MOJO-reviews"] && !Shopify.designMode) return;
  try {
    
const container = document.querySelector('.review-carousel__inner');
const prevBtn   = document.querySelector('.rc-prev');
const nextBtn   = document.querySelector('.rc-next');

if (container && prevBtn && nextBtn) {

  function scrollAmount() {
    let card = container.querySelector('.review-card');
    if (!card) return container.clientWidth * 0.8;
    return card.clientWidth + 20; /* card width + gap */
  }

  prevBtn.addEventListener('click', () => {
    container.scrollLeft -= scrollAmount();
  });

  nextBtn.addEventListener('click', () => {
    container.scrollLeft += scrollAmount();
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
